import { useTranslation } from "react-i18next"
import { ExternalResourcePage } from "@/components/ExternalResourcePage/ExternalResourcePage"

const legalResources = {
    terms: { title: "Terms of Use", src: "https://www.aidocr.com/en/terms" },
    privacy: { title: "Privacy Policy", src: "https://www.aidocr.com/en/privacy" },
    disclaimer: { title: "Disclaimer", src: "https://www.aidocr.com/en/disclaimer" },
    eula: { title: "End User License Agreement", src: "https://www.aidocr.com/en/eula" },
} as const

function LegalPage({ resource, fullPage = false }: { resource: keyof typeof legalResources; fullPage?: boolean }) {
    const { t } = useTranslation()
    const { title, src } = legalResources[resource]
    return <ExternalResourcePage title={t(title)} src={src} fullPage={fullPage} />
}

export const PrivacyPolicyInner = () => <LegalPage resource="privacy" />
export const EULAInner = () => <LegalPage resource="eula" />
export const DisclaimerInner = () => <LegalPage resource="disclaimer" />
export const TermsOfUseInner = () => <LegalPage resource="terms" />
export const TermsOfUsePage = () => <LegalPage resource="terms" fullPage />
export const PrivacyPolicyPage = () => <LegalPage resource="privacy" fullPage />
export const DisclaimerPage = () => <LegalPage resource="disclaimer" fullPage />
export const EULAPage = () => <LegalPage resource="eula" fullPage />
